import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import { useAuthModal } from '@features/common/protected-auth-route/model.ts';

export const useResetPasswordModal = () => {
  const { openAuth } = useAuthModal();
  const { data, doSetStorageData, doRemoveStorageData } = useSaveData<{
    type: string;
    head: string;
  }>('reset-password');

  const openResetPasswordModal = useCallback(() => {
    doSetStorageData({ type: 'resetPassword', head: 'Смена пароля' });
    openAuth();
  }, [doSetStorageData, openAuth]);

  return {
    openResetPasswordModal,
    openedTabInfo: data,
    resetOpenedTabInfo: doRemoveStorageData,
  };
};
